// TODO: Add values for these variables in .env.test & .env.production. Double check once access to Azure is granted
export const REACT_APP_TRACKING_API_ENDPOINT = process.env.REACT_APP_PHOENIX_TRACKING_API_ENDPOINT;
export const REACT_APP_TRACKING_CMD_API_ENDPOINT = process.env.REACT_APP_PHOENIX_TRACKING_CMD_API_ENDPOINT;
export const REACT_APP_AUTH_API_ENDPOINT = process.env.REACT_APP_PHOENIX_AUTH_API_ENDPOINT;
export const REACT_APP_ROUTE_MANAGER_API_ENDPOINT = process.env.REACT_APP_PHOENIX_ROUTE_MANAGER_API_ENDPOINT;
export const REACT_APP_TRACKING_GRAPH_ENDPOINT = process.env.REACT_APP_PHOENIX_TRACKING_GRAPH_ENDPOINT;
export const REACT_APP_SHARE_MANAGER_API_ENDPOINT = process.env.REACT_APP_PHOENIX_SHARE_MANAGER_API_ENDPOINT;
export const REACT_APP_SHARE_MANAGER_CMD_API_ENDPOINT = process.env.REACT_APP_PHOENIX_SHARE_MANAGER_CMD_API_ENDPOINT;
export const REACT_APP_BASE_URL = process.env.REACT_APP_PHOENIX_BASE_URL;
export const REACT_APP_IMARDA_BASE_URL = process.env.REACT_APP_PHOENIX_IMARDA_BASE_URL;
export const REACT_APP_LEGACY_LOGIN = process.env.REACT_APP_PHOENIX_LEGACY_LOGIN;
export const NPM_TOKEN = process.env.REACT_APP_PHOENIX_NPM_TOKEN;
export const PUBLIC_URL = process.env.REACT_APP_PHOENIX_PUBLIC_URL;
export const REACT_APP_APPINSIGHTS_KEY = process.env.REACT_APP_PHOENIX_APPINSIGHTS_KEY;
export const REACT_APP_UNIDENTIFIED_DRIVING_API_ENDPOINT =
  process.env.REACT_APP_PHOENIX_UNIDENTIFIED_DRIVING_API_ENDPOINT;

import type { NavigateFunction } from "react-router";

export class Config {
  token: string | undefined;
  navigate: NavigateFunction | undefined;

  constructor(token: string | undefined, navigate?: NavigateFunction) {
    this.token = token;
    this.navigate = navigate;
  }

  getAuthorizationHeader = (): Record<string, string> => {
    if (this.token === undefined || this.token === "") {
      return {};
    }

    return {
      Authorization: `Bearer ${this.token}`,
    };
  };
}
